module.exports = __webpack_public_path__ + "media/images/lb/900-1e5121c21a5c6a7a7ce6f15b3e6fc0c5.svg";